import {isPossiblePhoneNumber} from "react-phone-number-input";

export const checkPhoneLength = (phone: string, setErr: any): void => {
  if (phone && !isPossiblePhoneNumber(phone)) {
    setErr("Вы ввели неверный формат номера")
  }
}
